<template>
  <div class="ui-section-header" :class="{ 'ui-section-header--stacked': stacked }">
    <div class="ui-section-header__copy">
      <p v-if="kicker" class="ui-section-header__kicker">{{ kicker }}</p>
      <h2>{{ title }}</h2>
      <p v-if="description" class="ui-section-header__description">{{ description }}</p>
    </div>
    <div v-if="$slots.actions" class="ui-section-header__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: "HsSectionHeader",
  props: {
    kicker: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    stacked: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.ui-section-header {
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  min-width: 0;
}

.ui-section-header--stacked {
  align-items: flex-start;
  flex-direction: column;
}

.ui-section-header__copy {
  min-width: 0;
}

.ui-section-header__kicker {
  color: var(--hs-primary, #3293ec);
  font-size: 0.72rem;
  font-weight: 950;
  letter-spacing: 0.12em;
  margin: 0 0 0.35rem;
  text-transform: uppercase;
}

.ui-section-header h2 {
  color: var(--hs-text, #0f172a);
  font-size: 1.35rem;
  font-weight: 950;
  letter-spacing: 0;
  line-height: 1.1;
  margin: 0;
}

.ui-section-header__description {
  color: var(--hs-muted, #64748b);
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.55;
  margin: 0.45rem 0 0;
}

.ui-section-header__actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  justify-content: flex-end;
}

@media (max-width: 720px) {
  .ui-section-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .ui-section-header__actions {
    width: 100%;
  }
}
</style>
